import { extractDefaultValues } from '@wix/editor-elements-panel';
import { skinDefinition } from './Breadcrumbs.skinParams';

export enum HelpIds {
  GFPP = 'c8b1d3da-3897-462d-ae99-a570747e2e67',
  GFPP_MOBILE = 'c8b1d3da-3897-462d-ae99-a570747e2e67',
  GFPP_BLOCKS = 'component-editors.wixui.blocks-Breadcrumbs_help',
  GFPP_RESPONSIVE = 'component-editors.wixui.Breadcrumbs_help',
  LAYOUT_PANEL = '2c701e19-7f1a-4081-9541-f88a4d166223',
  LAYOUT_PANEL_STUDIO = '3dacdc97-36e6-4a7d-8217-c5864510f671',
  LAYOUT_PANEL_BLOCKS = 'eb1d6d53-e028-42e6-8b15-3b62cc1db3e9',
  LAYOUT_PANEL_MOBILE = 'b5390156-fb7e-400e-aa5e-ff8143dbd7b0',
  SETTINGS_PANEL = 'f2681461-1aa8-45ab-ac3f-a9a6349fe8f8',
  SETTINGS_PANEL_STUDIO = 'a5d719d4-7dd5-4542-afc3-131cc1cf0510',
  SETTINGS_PANEL_BLOCKS = '6fa4b894-89bc-4baa-8cbe-1955ce49f037',
  SETTINGS_PANEL_MOBILE = '5f324e8b-c209-4043-8fd2-894fafc7600d',
}

export const udpComponentStructure = {
  type: 'Component',
  skin: 'wixui.skins.Breadcrumbs',
  layout: {
    width: 304,
    height: 36,
    x: 20,
    y: 20,
    scale: 1,
    rotationInDegrees: 0,
    fixedPosition: false,
  },
  componentType: 'wixui.Breadcrumbs',
  data: {
    svgId: 'f2ac30_5b22d370308a4890a7c229cfd3660239.svg',
    menuRef: '#CUSTOM_MAIN_MENU',
    type: 'BreadcrumbsData',
  },
  props: {
    shouldWrap: true,
    verticalMargin: 0,
    separator: 'slash',
    showCurrentPage: true,
    direction: 'ltr',
    showHomePageAsIcon: false,
    showOnlyPreviousPageOnMobile: false,
    horizontalMargin: 0,
    alignment: 'flex-start',
    itemsBeforeCollapse: 1,
    itemsAfterCollapse: 1,
    isCollapsedByDefault: true,
    type: 'BreadcrumbsProperties',
    showHomePage: true,
  },
  style: {
    type: 'ComponentStyle' as const,
    style: {
      properties: {
        ...extractDefaultValues(skinDefinition),
        'separator-label-display': 'initial',
        'border-left': '0px none #000000',
        'border-right': '0px none #000000',
        'border-top': '0px none #000000',
        'border-bottom': '0px none #000000',
        'border-top-left-radius': '0',
        'border-top-right-radius': '0',
        'border-bottom-left-radius': '0',
        'border-bottom-right-radius': '0',
        'text-shadow': '0px 0px 0px transparent',
        'breadcrumb-content-font': 'font_8',
        'separator-font': 'font_8',
        'separator-color': '#000000',
        'separator-text-shadow': '0px 0px 0px transparent',
        'separator-text-outline':
          '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
        'breadcrumb-content-border-left': '0px none #000000',
        'breadcrumb-content-border-right': '0px none #000000',
        'breadcrumb-content-border-top': '0px none #000000',
        'breadcrumb-content-border-bottom': '0px none #000000',
        'breadcrumb-content-border-top-left-radius': '0',
        'breadcrumb-content-border-top-right-radius': '0',
        'breadcrumb-content-border-bottom-left-radius': '0',
        'breadcrumb-content-border-bottom-right-radius': '0',
        'breadcrumb-content-background': 'rgba(0,0,0,0)',
        'breadcrumb-content-text-shadow': '0px 0px 0px transparent',
        'breadcrumb-content-text-outline':
          '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
        font: 'font_8',
        color: '#000000',
        'padding-bottom': '0',
        'padding-top': '0',
        'padding-left': '0',
        'padding-right': '0',
        background: 'rgba(0,0,0,0)',
        'box-shadow': 'none',
      },
      propertiesSource: {},
    },
    componentClassName: 'wixui.Breadcrumbs',
    pageId: '',
    compId: '',
    styleType: 'custom',
    skin: 'wixui.skins.Breadcrumbs',
  },
};

export const ARIA_LABEL_NAMESPACE = 'ariaLabels';
export const ARIA_LABEL_KEY = 'breadcrumbs_AriaLabel';
export const ARIA_LABEL_DEFAULT = 'breadcrumbs';

export const ariaLabelExperiment = 'specs.santa-editor.BreadcrumbsAriaLabel';
